module.exports = __webpack_public_path__ + "img/poll-h.ae98a97d.svg";